module.exports = __webpack_public_path__ + "img/header-memoireRingsRedgold@2x.1ef0a1d.jpg";